import styles from "./Details.module.css";
import { Input } from "../../../common/Input";
import { useForm } from "react-hook-form";
import { ButtonFooter } from "../../../common/ButtonFooter";
import { PayWithButton } from "../../../common/PayWithButton";
import { useState } from "react";

export const Details = ({
  onContinue,
  isLoading,
}: {
  onContinue: () => void;
  isLoading: boolean;
}) => {
  const { register, handleSubmit, getValues } = useForm();

  const values = getValues();

  const [value, setValue] = useState(values);

  const handleInputChange = (e: any) => {
    e.preventDefault();
    setValue({
      ...value,
      [e.target.inputId]: e.target.value,
    });
  };

  console.log(values);

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit(onContinue)}>
        <div className={styles.form}>
          <Input
            register={register}
            inputId="firstName"
            type="text"
            labelfocus="First name"
            placeholder="First name"
            onChange={handleInputChange}
            // required
          />
          <Input
            register={register}
            inputId="lastName"
            type="text"
            labelfocus="Last name"
            placeholder="Last name"
            onChange={handleInputChange}
            // required
          />
        </div>
        <ButtonFooter showNote>
          <PayWithButton
            isDisabled={!values?.firstName?.length || !values?.lastName?.length}
            isLoading={isLoading}
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
